// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StepForwardOutlinedSvg from "@ant-design/icons-svg/es/asn/StepForwardOutlined";
import AntdIcon from '../components/AntdIcon';

var StepForwardOutlined = function StepForwardOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: StepForwardOutlinedSvg
  }));
};

StepForwardOutlined.displayName = 'StepForwardOutlined';
export default React.forwardRef(StepForwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/StepForwardOutlined.js
// module id = 1875
// module chunks = 0